<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>职能管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operating">
      <span> <el-button type="primary" size="small" @click="addDialog" >添加职能</el-button></span>
    </div>
    <div>
      <template>
        <el-table
          :data="tableData"
          stripe
          center
          border
          highlight-current-row
          style="width: 100%">
          <el-table-column
            align="center"
            prop="role_name"
            width="220"
            label="职能名称">
          </el-table-column>
          <el-table-column
            align="center"
            label="职能权限">
            <template slot-scope="scope">
              <el-popover
                placement="right"
                width="400"
                trigger="click">
                <div>
                  <el-tree :data="menuTree" :props="{label: 'name', children: 'child'}" accordion highlight-current></el-tree>
                </div>
                <el-link type="primary" @click="getRoleMenus(scope.row.id)" slot="reference">查看权限</el-link>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="320">
            <template slot-scope="scope" >
              <el-button
                type="primary"
                size="small"
                v-show="scope.row.id !== 1000"
                @click="editDialog(scope.row.id)">编辑
              </el-button>
              <el-popconfirm
                v-show="scope.row.id !== 1000"
                confirmButtonText='确认'
                cancelButtonText='取消'
                icon="el-icon-info"
                iconColor="red"
                title="删除不可恢复，确定删除吗？"
                @onConfirm="del(scope.row.id)"
              >
                <el-button type="primary" size="small" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="block page-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page=page
            :page-sizes="[50, 100, 200, 500]"
            :page-size=page_size
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
        </div>
      </template>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false"  width="600px" class="padding_10">
      <el-form :model="form" label-width="120px" :rules="storeRoleRules" ref="form">
        <el-form-item label="职能名称" prop="role_name">
          <el-input v-model="form.role_name" auto-complete="off" placeholder="请输入职能名称"></el-input>
        </el-form-item>
        <el-form-item label="职能权限" prop="menus">
          <el-cascader
            style="width: 100%"
            v-model="form.menus"
            :options="menuAllTree"
            :props="{label: 'name', children: 'child',value: 'id', multiple: true}"
            collapse-tags
            clearable>
          </el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="add">确 定</el-button>
        <el-button @click="callOf">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style lang="scss" >
  .el-transfer__button{
    display: block!important;
    width: 100%;
  }
  .el-button+.el-button{
    margin: 0;
  }
  .el-checkbox{
    margin: 0;
    text-align: left;
  }
  .el-transfer-panel__item{
    width: 100%;
    max-width: 200px;
  }
  .el-transfer-panel__list{
    overflow-x:hidden;
  }
</style>

<script>
import {addRole, delRole, editRole, menuAll, roleInfo, roleList} from '../../api/auth'

export default {
  data () {
    return {
      dialogVisible: false,
      loading: false,
      dialogTitle: '',
      tableData: [],
      page: 1,
      menuTree: [],
      menuAllTree: [],
      page_size: 50,
      total: 0,
      form: {
        id: 0,
        role_name: '',
        menus: []
      },
      storeRoleRules: {
        role_name: [
          { required: true, message: '请输入职能名称', trigger: 'blur' }
        ],
        menus: [
          { required: true, message: '请选择职能权限', trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    this.setTableData()
    this.getMenuList()
  },
  methods: {
    // 获取指定角色的菜单结构
    getRoleMenus (id) {
      roleInfo({id: id}).then(res => {
        let {status} = res
        if (status === 2000) {
          this.menuTree = res.data.menus
        } else {
          this.menuTree = []
        }
      })
    },
    // 分页大小切换回调
    handleSizeChange (val) {
      this.page_size = val
      this.setTableData()
    },
    // 页码切换回调
    handleCurrentChange (val) {
      this.page = val
      this.setTableData()
    },
    // 表格渲染
    setTableData () {
      roleList({
        page: this.page,
        page_size: this.page_size
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.total = res.data.total
          this.tableData = res.data.table_list
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 添加弹窗
    addDialog () {
      this.dialogTitle = '添加职能'
      this.dialogVisible = true
    },
    // 关闭弹窗
    callOf () {
      this.dialogVisible = false
      this.$refs['form'].resetFields()
    },
    // 获取所有菜单
    getMenuList () {
      menuAll().then(res => {
        let {status} = res
        if (status === 2000) {
          this.menuAllTree = res.data
        } else {
          this.menuAllTree = []
        }
      })
    },
    // 添加职能
    add () {
      this.loading = true
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          let res = {}
          if (this.form.id === 0) {
            res = await addRole(this.form)
          } else {
            res = await editRole(this.form)
          }
          let {status, message} = res
          if (status === 2000) {
            this.$refs['form'].resetFields()
            setTimeout(() => {
              this.dialogVisible = false
            }, 200)
            this.setTableData()
          }
          this.$notify({
            message: message,
            type: status === 2000 ? 'success' : 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 编辑弹窗
    editDialog (id) {
      this.dialogVisible = true
      this.dialogTitle = '编辑职能'
      roleInfo({id: id}).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.form.id = id
          this.form.role_name = res.data.role_name
          this.form.menus = this.getMenuIdRecursion(res.data.menus)
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 获取菜单树形结构的关联id列表
    getMenuIdRecursion (menus) {
      let idArr = []
      menus.forEach((item) => {
        if ('child' in item) {
          let childId = this.getMenuIdRecursion(item.child)
          console.log(childId)
          childId.forEach(c => {
            if (c instanceof Array) {
              c.unshift(item.id)
              idArr.push(c)
            } else {
              idArr.push([item.id, c])
            }
          })
        } else {
          idArr.push(item.id)
        }
      })
      return idArr
    },
    // 删除职能
    del (id) {
      delRole({id: id}).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.setTableData()
        }
        this.$notify({
          message: message,
          type: status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/role/index.vue